import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { DecimalPipe } from '@angular/common';
import { ProductionKeyPerformanceIndicatorEvaluation } from 'src/app/models/production-key-performance-indicator-evaluation.model';
import { MeetingAttendanceEvaluatorData, MEETING_ATTENDANCE_DEFAULT } from 'src/app/models/meeting-attendance-kpi-data.model';

@Component({
  selector: 'app-meeting-attendance-details',
  imports: [MatDividerModule, DecimalPipe],
  templateUrl: './meeting-attendance-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './meeting-attendance-details.component.css',
})
export class MeetingAttendanceDetailsComponent {
  currentMonthEvaluation = input<ProductionKeyPerformanceIndicatorEvaluation | null>(null);

  meetingAttendanceData = computed<MeetingAttendanceEvaluatorData>(() => {
    const data = this.currentMonthEvaluation()?.data as MeetingAttendanceEvaluatorData | undefined;
    return data ?? MEETING_ATTENDANCE_DEFAULT;
  });
}
